import { Link } from 'react-router-dom';

export default function KaraokeNightBanner() {
  return (
    <section className="py-16 px-4 relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/a8dbeea2583fd0cd491dd0e3e8d6cf3d.jpg"
          alt="Tokyo Karaoke Night"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-purple-900/85 via-pink-900/80 to-blue-900/85"></div>
      </div>

      {/* Content */}
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-6">
            <i className="ri-music-2-fill text-pink-300 text-lg"></i>
            <span className="text-white text-sm font-medium">New Experience</span>
          </div>

          {/* Main Heading */}
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Try Japanese Karaoke<br />During Your Stay!
          </h2>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-pink-200 mb-3 font-medium">
            No stress. Just fun.
          </p>

          <p className="text-base md:text-lg text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed">
            Experience authentic Japanese karaoke with a local friend.<br />
            We'll handle booking, machine setup, and song recommendations.
          </p>

          {/* Features */}
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
              <i className="ri-calendar-check-line text-pink-300"></i>
              <span className="text-white text-sm">Pre-booking</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
              <i className="ri-customer-service-2-line text-purple-300"></i>
              <span className="text-white text-sm">Full Support</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
              <i className="ri-music-fill text-blue-300"></i>
              <span className="text-white text-sm">J-Pop & Anime</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
              <i className="ri-group-line text-pink-300"></i>
              <span className="text-white text-sm">Up to 4 People</span>
            </div>
          </div>

          {/* Pricing */}
          <div className="inline-block bg-gradient-to-r from-pink-500 to-purple-500 rounded-2xl p-1 mb-8">
            <div className="bg-gray-900 rounded-xl px-6 py-4">
              <p className="text-pink-200 text-sm mb-1">3 Hours Package</p>
              <p className="text-white text-3xl font-bold">¥18,000<span className="text-lg font-normal text-white/70"> / 1-2 people</span></p>
              <p className="text-white/60 text-xs mt-1">+¥5,000 per additional person (max 4)</p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/tokyo-karaoke-night-en"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-500 to-purple-500 text-white px-8 py-4 rounded-full font-semibold text-lg hover:from-pink-600 hover:to-purple-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mic-fill text-xl"></i>
              <span>View Details (English)</span>
            </Link>
            <Link
              to="/tokyo-karaoke-night"
              className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span>日本語で見る</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}